import React from "react";
import "./style.css"

function Footer() {
  return (
    <footer className="footer mt-auto py-3">
      <div className="container">
        <span className="text-muted">&Copyright</span>
      </div>
    </footer>
  );
}

export default Footer;